module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lightningIcon@2x_869211.png";